import { createActions } from 'redux-actions';

export const { fakePaymentCreate } = createActions({ FAKE_PAYMENT_CREATE: undefined }, { prefix: 'FAKE_PAYMENT' });
